import React from 'react';
import { b64toBlob, formatBytes, triggerBlobDownload } from '../lib/utils';
import { LeafMimeNode, MimeNode } from '../gflib/src/lib/mime-tree/types';
import { observer } from 'mobx-react-lite';

interface DownloadProps {
    node: MimeNode
}

const AttachDownloadButton = observer((props: DownloadProps) => {
    const body = (props.node as LeafMimeNode).rawBody;
    const fileName = props.node.contentDispositionFilename;
    if(body) {
        const blob = b64toBlob(body);
        const fileSize = formatBytes(blob.size);
        return (
            <div className="download-btn" onClick={() => {
                triggerBlobDownload(blob, fileName?fileName:'unknownfile.txt');
            }}>
                <div className="flex-mother-col flex-1">
                    <div className="flex-1" />
                    <div>{fileName}</div>    
                    <div className="flex-1" />
                </div>
                <div className="flex-mother-col">
                    <div className="flex-1" />
                    <div>{fileSize}</div>    
                    <div className="flex-1" />
                </div>
            </div>
        );
    }
    return <div>Unhandlable file: {fileName}</div>;
});

export default AttachDownloadButton;